import React from 'react'
import Liste from './Liste'

const Senior = () => {
  return (
    <div>
        <Liste page="senior"/>
    </div>
  )
}

export default Senior